import styles from "./styles/mastering-preset-tab.module.scss";
import PresetItem from "@/components/pages/ai-mastering/components/preset-item";
import { useAiMastering } from "@/components/pages/ai-mastering/providers/ai-mastering-provider";
import { useMobile } from "@/hooks/use-responsive";
import React from "react";
import StyledDropdown from "@/components/common/styled-dropdown";

const MasteringPresetTab = () => {
  const { setSelectedPreset, selectedPreset, currentOptionTab } =
    useAiMastering();

  const { isMobile } = useMobile();

  if (currentOptionTab !== "preset") {
    return <></>;
  }

  const presetList = [
    { text: "Light & Bright", value: "light_n_bright" },
    { text: "Bass Heavy", value: "bass_heavy" },
    { text: "Punch & Air", value: "punch_n_air" },
    { text: "Lush", value: "lush" },
    { text: "Tape Glue", value: "tape_glue" },
    { text: "Analog Warmth", value: "analog_warmth" },
    { text: "Natural", value: "natural" },
    { text: "Fire", value: "fire" },
    { text: "Punch", value: "punch" },
    { text: "Tape", value: "tape" },
    { text: "Cinematic", value: "cinematic" },
    { text: "Spatial", value: "spatial" },
  ];

  return (
    <div className={styles.mastering_preset_list}>
      {isMobile ? (
        <StyledDropdown
          values={presetList.map((preset) => preset.text)}
          onChanged={(value) =>
            setSelectedPreset(
              presetList.find((preset) => preset.text === value)?.value,
            )
          }
          currentValue={
            presetList.find((preset) => preset.value === selectedPreset)
              ?.text ?? "Select a Preset"
          }
        />
      ) : (
        presetList.map((preset) => (
          <PresetItem
            key={preset.value}
            value={preset.value}
            text={preset.text}
            onClick={(value) => setSelectedPreset(value)}
            selected={selectedPreset === preset.value}
          />
        ))
      )}
    </div>
  );
};

export default MasteringPresetTab;
